import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LicenseInfo, SiAboutComponent } from '@siemens/element-ng/about';
import { environment } from 'src/environments/environment';

import { SettingsService } from '../main/shared/services/settings.service';
import { ShareDataService } from '../main/shared/services/share-data.service';

@Component({
  selector: 'app-about',
  imports: [SiAboutComponent, TranslateModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent implements OnInit {
  shareDataService = inject(ShareDataService);
  translateService = inject(TranslateService);
  settingsService = inject(SettingsService);
  private http = inject(HttpClient);

  fullApplicationTitle = '';
  applicationVersion = '';
  header = '';

  licenseInfo: LicenseInfo = {
    title: 'Open Source Licenses',
    text: 'License information is only available in production builds.'
  };

  ngOnInit(): void {
    this.translateService.setFallbackLang('en');
    this.translateService.use('en');
    this.fullApplicationTitle = this.shareDataService.getFullApplicationName();
    this.applicationVersion = this.shareDataService.getApplicationVersion();

    if (environment.production) {
      this.http.get('3rdpartylicenses.txt', { responseType: 'text' }).subscribe({
        next: text => (this.licenseInfo = { title: 'Open Source Licenses', text }),
        error: () =>
          (this.licenseInfo = {
            title: 'Open Source Licenses',
            text: 'Could not load license information.'
          })
      });
    }
  }
}
